import { render, staticRenderFns } from "./TableListAccessUser.vue?vue&type=template&id=484567fc"
import script from "./TableListAccessUser.vue?vue&type=script&lang=js"
export * from "./TableListAccessUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484567fc')) {
      api.createRecord('484567fc', component.options)
    } else {
      api.reload('484567fc', component.options)
    }
    module.hot.accept("./TableListAccessUser.vue?vue&type=template&id=484567fc", function () {
      api.rerender('484567fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserDetail/TableListAccessUser.vue"
export default component.exports